export default {"src":"/_next/static/media/icon_percentage.79976f30.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};